export const ALL_PERMISSIONS = {

  API_ACCESS: "apiAccess",

  SHARE_BRAND_ADD: "shareBrandAdd",
  ASSIGN_BRAND_ADD: "assignBrandAdd",
  ASSIGN_BRAND_DELETE: "assignBrandDelete",

  KANBAN_EDIT: "kanbanEdit",
  KANBAN_VIEW: "kanbanView",


  IDEA_VIEW: "ideaView",
  IDEA_ADD: "ideaAdd",
  IDEA_EDIT: "ideaEdit",
  IDEA_DELETE: "ideaDelete",

  COMMUNITY_VIEW: "communityView",
  COMMUNITY_ADD: "communityAdd",
  COMMUNITY_EDIT: "communityEdit",
  COMMUNITY_DELETE: "communityDelete",


 BRAND_ADD: "brandAdd",
 BRAND_EDIT: "brandEdit",
 BRAND_DELETE: "brandDelete",
 BRAND_VIEW: "brandView",


 POST_SHARE: "postShare",
 POST_VIEW: "postView",
 POST_EDIT: "postEdit",
 POST_DELETE: "postDelete",

  USER_ADD: "userAdd",
  USER_EDIT: "userEdit",
  USER_DELETE: "userDelete",
  USER_VIEW: "userView",
  USER_IMPORT: "userImport",
  


  STATUS_VIEW: "statusView",
  STATUS_ADD: "statusAdd",
  STATUS_EDIT: "statusEdit",
  STATUS_DELETE: "statusDelete",
  STATUS_IMPORT: "statusImport",

  // Hot Topics (Brands sub-feature) — gated on its own perms (not brandView)
  // so Brands access alone does not grant Hot Topics. read = hotTopicView,
  // mutate (analyze / assign / delete) = hotTopicEdit.
  HOT_TOPIC_VIEW: "hotTopicView",
  HOT_TOPIC_EDIT: "hotTopicEdit",



 BRAND_SETTINGS_VIEW: "brandSettingsView",
 BRAND_SETTINGS_EDIT: "brandSettingsEdit",
 BRAND_SETTINGS_ADD: "brandSettingsAdd",

  ROLE_ADD: "roleAdd",
  ROLE_EDIT: "roleEdit",
  ROLE_DELETE: "roleDelete",

  ADMIN_SECTION_ACCESS: "adminSectionAccess",


  AFFILIATIONS_VIEW: 'affiliationView',
  AFFILIATIONS_ADD: 'affiliationAdd',
  AFFILIATIONS_EDIT: 'affiliationEdit',


  BRAND_MANAGEMENT: "brandManagement",

  // Social Media Management package perms.
  SOCIAL_POSTING_VIEW: "socialPostingView",
  SOCIAL_POSTING_EDIT: "socialPostingEdit",
  AI_GENERATION_USE: "aiGenerationUse",
  AUTOMATION_MANAGE: "automationManage",
  API_COST_VIEW: "apiCostView",

  // SEO Management package — keyword research + briefs + articles + FAQ.
  SEO_VIEW: "seoView",
  SEO_EDIT: "seoEdit",
  SEO_KEYWORD_VIEW: "seoKeywordView",
  SEO_KEYWORD_ADD: "seoKeywordAdd",
  SEO_KEYWORD_EDIT: "seoKeywordEdit",
  SEO_KEYWORD_DELETE: "seoKeywordDelete",
  SEO_BRIEF_VIEW: "seoBriefView",
  SEO_BRIEF_ADD: "seoBriefAdd",
  SEO_BRIEF_EDIT: "seoBriefEdit",
  SEO_BRIEF_DELETE: "seoBriefDelete",
  SEO_BRIEF_REQUEST: "seoBriefRequest",
  SEO_ARTICLE_VIEW: "seoArticleView",
  SEO_ARTICLE_ADD: "seoArticleAdd",
  SEO_ARTICLE_EDIT: "seoArticleEdit",
  SEO_ARTICLE_DELETE: "seoArticleDelete",
  SEO_ARTICLE_REQUEST: "seoArticleRequest",
  SEO_ARTICLE_PUBLISH: "seoArticlePublish",
  SEO_PUBLISH_TARGET_VIEW: "seoPublishTargetView",
  SEO_PUBLISH_TARGET_EDIT: "seoPublishTargetEdit",
  SEO_FAQ_VIEW: "seoFaqView",
  SEO_FAQ_ADD: "seoFaqAdd",
  SEO_FAQ_EDIT: "seoFaqEdit",
  SEO_FAQ_DELETE: "seoFaqDelete",
  SEO_FAQ_ANSWER_REQUEST: "seoFaqAnswerRequest",

  // Chat Support Management package — widget + cross-channel inbox + KB.
  CHAT_INBOX_VIEW: "chatInboxView",
  CHAT_INBOX_RESPOND: "chatInboxRespond",
  CHAT_CHANNEL_VIEW: "chatChannelView",
  CHAT_CHANNEL_ADD: "chatChannelAdd",
  CHAT_CHANNEL_EDIT: "chatChannelEdit",
  CHAT_CHANNEL_DELETE: "chatChannelDelete",
  CHAT_CONVERSATION_VIEW: "chatConversationView",
  CHAT_CONVERSATION_REPLY: "chatConversationReply",
  CHAT_CONVERSATION_ASSIGN: "chatConversationAssign",
  CHAT_CONVERSATION_CLOSE: "chatConversationClose",
  CHAT_KNOWLEDGE_VIEW: "chatKnowledgeView",
  CHAT_KNOWLEDGE_ADD: "chatKnowledgeAdd",
  CHAT_KNOWLEDGE_EDIT: "chatKnowledgeEdit",
  CHAT_KNOWLEDGE_DELETE: "chatKnowledgeDelete",
  CHAT_AUTOREPLY_MANAGE: "chatAutoReplyManage",

  // Lead Acquisition package — per-brand prospect crawler. Three tabs:
  // crawler runner, collected leads, list builder.
  LEAD_ACQUISITION_VIEW: "leadAcquisitionView",
  LEAD_ACQUISITION_EDIT: "leadAcquisitionEdit",
  LEAD_CRAWLER_VIEW: "leadCrawlerView",
  LEAD_CRAWLER_RUN: "leadCrawlerRun",
  LEAD_VIEW: "leadView",
  LEAD_EDIT: "leadEdit",
  LEAD_DELETE: "leadDelete",
  LEAD_LIST_VIEW: "leadListView",
  LEAD_LIST_ADD: "leadListAdd",
  LEAD_LIST_EDIT: "leadListEdit",
  LEAD_LIST_DELETE: "leadListDelete",

  // Email Management package — full feature set.
  EMAIL_ACCOUNT_VIEW: "emailAccountView",
  EMAIL_ACCOUNT_ADD: "emailAccountAdd",
  EMAIL_ACCOUNT_EDIT: "emailAccountEdit",
  EMAIL_ACCOUNT_DELETE: "emailAccountDelete",

  EMAIL_MESSAGE_VIEW: "emailMessageView",
  EMAIL_MESSAGE_SEND: "emailMessageSend",

  EMAIL_CAMPAIGN_VIEW: "emailCampaignView",
  EMAIL_CAMPAIGN_ADD: "emailCampaignAdd",
  EMAIL_CAMPAIGN_EDIT: "emailCampaignEdit",
  EMAIL_CAMPAIGN_DELETE: "emailCampaignDelete",
  EMAIL_CAMPAIGN_LAUNCH: "emailCampaignLaunch",

  EMAIL_TEMPLATE_VIEW: "emailTemplateView",
  EMAIL_TEMPLATE_ADD: "emailTemplateAdd",
  EMAIL_TEMPLATE_EDIT: "emailTemplateEdit",
  EMAIL_TEMPLATE_DELETE: "emailTemplateDelete",

  EMAIL_CONTACT_VIEW: "emailContactView",
  EMAIL_CONTACT_ADD: "emailContactAdd",
  EMAIL_CONTACT_EDIT: "emailContactEdit",
  EMAIL_CONTACT_DELETE: "emailContactDelete",
  EMAIL_CONTACT_IMPORT: "emailContactImport",

  EMAIL_LIST_VIEW: "emailListView",
  EMAIL_LIST_ADD: "emailListAdd",
  EMAIL_LIST_EDIT: "emailListEdit",
  EMAIL_LIST_DELETE: "emailListDelete",

  EMAIL_INTENT_VIEW: "emailIntentView",
  EMAIL_INTENT_ADD: "emailIntentAdd",
  EMAIL_INTENT_EDIT: "emailIntentEdit",
  EMAIL_INTENT_DELETE: "emailIntentDelete",

  EMAIL_AUTOREPLY_MANAGE: "emailAutoReplyManage",

  // Email sequences — AI-generated drip campaigns (EmailManagement sub-feature).
  EMAIL_SEQUENCE_VIEW: "emailSequenceView",
  EMAIL_SEQUENCE_ADD: "emailSequenceAdd",
  EMAIL_SEQUENCE_EDIT: "emailSequenceEdit",
  EMAIL_SEQUENCE_DELETE: "emailSequenceDelete",
  EMAIL_SEQUENCE_GENERATE: "emailSequenceGenerate",
  EMAIL_SEQUENCE_LAUNCH: "emailSequenceLaunch",

  // External CRM source connectors (pull users from brand systems).
  CRM_SOURCE_VIEW: "crmSourceView",
  CRM_SOURCE_ADD: "crmSourceAdd",
  CRM_SOURCE_EDIT: "crmSourceEdit",
  CRM_SOURCE_DELETE: "crmSourceDelete",
  CRM_SOURCE_SYNC: "crmSourceSync",

  // Newsletter — recurring AI-driven campaigns (EmailManagement sub-feature).
  NEWSLETTER_SCHEDULE_VIEW: "newsletterScheduleView",
  NEWSLETTER_SCHEDULE_ADD: "newsletterScheduleAdd",
  NEWSLETTER_SCHEDULE_EDIT: "newsletterScheduleEdit",
  NEWSLETTER_SCHEDULE_DELETE: "newsletterScheduleDelete",
  NEWSLETTER_ISSUE_VIEW: "newsletterIssueView",
  NEWSLETTER_ISSUE_GENERATE: "newsletterIssueGenerate",
  NEWSLETTER_ISSUE_LAUNCH: "newsletterIssueLaunch",

  // Newsletter subscription widget channels — collect names + emails,
  // chat-widget style, into the list the schedule delivers to.
  NEWSLETTER_CHANNEL_VIEW: "newsletterChannelView",
  NEWSLETTER_CHANNEL_ADD: "newsletterChannelAdd",
  NEWSLETTER_CHANNEL_EDIT: "newsletterChannelEdit",
  NEWSLETTER_CHANNEL_DELETE: "newsletterChannelDelete",

  // Invoice Management package — create brand invoices (line-item math + tax)
  // → compile to a branded PDF → AI-drafted, perfectionist-polished payment
  // reminder flows on a cadence (stop only on confirmed payment) → analytics.
  // Wired to the CRM/Email contacts (reminder targets) + the brand.
  INVOICE_VIEW: "invoiceView",
  INVOICE_ADD: "invoiceAdd",
  INVOICE_EDIT: "invoiceEdit",
  INVOICE_DELETE: "invoiceDelete",
  INVOICE_SEND: "invoiceSend",
  INVOICE_REMINDER_VIEW: "invoiceReminderView",
  INVOICE_REMINDER_ADD: "invoiceReminderAdd",
  INVOICE_REMINDER_EDIT: "invoiceReminderEdit",
  INVOICE_REMINDER_DELETE: "invoiceReminderDelete",
  INVOICE_PAYMENT_CONFIRM: "invoicePaymentConfirm",
  INVOICE_ANALYTICS_VIEW: "invoiceAnalyticsView",

  // Same package: the clients invoices are addressed to, the projects under
  // each, and the weekly timesheet logged against those projects.
  CLIENT_VIEW: "clientView",
  CLIENT_ADD: "clientAdd",
  CLIENT_EDIT: "clientEdit",
  CLIENT_DELETE: "clientDelete",
  TIME_ENTRY_VIEW: "timeEntryView",
  TIME_ENTRY_ADD: "timeEntryAdd",
  TIME_ENTRY_EDIT: "timeEntryEdit",
  TIME_ENTRY_DELETE: "timeEntryDelete",
};
